import { defaultObj } from './state'

// Utilities
import Device from '../../utility/deviceUtil'
import Logger from '../../utility/loggerUtil'
import { NotificationTypeEnum } from '../../constants'

export default {
  toggleSidebar (state) {
    state.sidebarOpen = !state.sidebarOpen
  },

  closeSidebar (state) {
    state.sidebarOpen = false
  },

  setMultipleAccounts (state, data) {
    state.multipleAccounts = data
  },

  showHidePaidOffToggle (state, data) {
    state.showAllLoansToggle = data
  },

  setShowAllLoans (state, data) {
    state.showAllLoans = data
  },

  preventScroll (state) {
    state.allowScroll = false
  },

  allowScroll (state) {
    state.allowScroll = true
  },

  preventHeaderClick (state) {
    state.preventHeaderClick = true
  },

  allowHeaderClick (state) {
    state.preventHeaderClick = false
  },

  setQuickMessage (state, data) {
    state.quickMessageText = data.message
    state.quickMessageType = data.isError ? NotificationTypeEnum.failure : NotificationTypeEnum.success
  },

  setDeviceBrowserInfo (state) {
    if (state.hasSetDeviceBrowser) {
      return
    }

    state.isMobileBrowser = Device.getIsMobileDevice()
    state.isTabletBrowser = Device.getIsTabletDevice()
    state.mobileOs = Device.getMobileOs()
    state.desktopOs = Device.getDesktopOs()
    state.browserType = Device.getBrowserType()
    state.isPwa = Device.getIsPwa()
    state.supportsPwaPrompt = window.hasOwnProperty('onbeforeinstallprompt')
    state.hasSetDeviceBrowser = true
  },

  updateHeader (state, headerData) {
    Logger.debug('Store header mutation data:')
    Logger.debug(JSON.stringify(headerData))

    if (headerData.hasOwnProperty('buttonType')) {
      state.header.buttonType = headerData.buttonType
    }

    if (headerData.hasOwnProperty('ariaHeader')) {
      state.ariaHeader = headerData.ariaHeader
    } else {
      state.ariaHeader = ''
    }
  },

  setForceWait (state, value) {
    state.forceWait = value
  },

  setWideViewport  (state) {
    state.wideViewport = window.innerWidth > 1000
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
